module.exports = __webpack_public_path__ + "img/LC-800.c33117c1.jpg";